export default __webpack_public_path__ + "static/media/watches.b22444f8.jpg";